export default {
  latest (state) {
    return state.news
  }
}
